export const ServiceNameLenta: string = 'Lenta-Web';
export const ServiceNameUtk: string = 'Utk-Web';
export const ServiceNameDom: string = 'DOM-Web';
export const ServiceNameMonetka: string = 'Monetka-Web';
export const ServiceNameSuperJam: string = 'SuperJam-Web';

export const OtelProdUrl: string = 'https://otel-collector.lo.lenta.tech/v1/traces';
export const OtelQAUrl: string = 'https://otel-collector-dev.lo.lenta.tech/v1/traces';
